export default {
  EVENTS_LINE_DATE: 'dd/MM',
  EVENTS_DETAILS_DATE: 'dd/MM'
};
